export const AppRoutes = {
    documents: '/documents',
    home: '/documents',
    admin: '/admin',
    signIn: '/signin',
    newsFeed : '/newsFeed',
    roles : '/roles',
    networkUpload : '/dataSource',
    users : '/admin',
   
}